import { render } from "./editParentMenu.vue?vue&type=template&id=f50299b4&scoped=true"
import script from "./editParentMenu.vue?vue&type=script&lang=js"
export * from "./editParentMenu.vue?vue&type=script&lang=js"

import "./editParentMenu.vue?vue&type=style&index=0&id=f50299b4&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50299b4"]])

export default __exports__